export default {
    shareLink : {
        content:{
            link:'https://one.yooda.com/webreport/r1e48s584s697hz8z599f88fhe88'
        }
    },
}
